<template>
    <div :style="style" class="z-10 fixed h-full">
        <div
            ref="draggableElement"
            class="aspect-[1/1.46] bg-base-100 shadow-2xl rounded p-1 flex flex-col"
            :style="{height: documentPreviewModalSize.height + 'px'}"
        >
            <div class="flex grow gap-2 p-2 items-center">
                <cycle-preset-size-button/>
                <hover-to-open-toggle/>
                <div
                    ref="dragHandler"
                    class="select-none grow"
                    :class="isDragging ? 'cursor-grabbing' : 'cursor-grab'"
                    title="Klikk og dra for å flytte forhåndsvisning"
                >
                    Forhåndsvisning
                </div>
                <UButton
                    icon="i-ph-x"
                    data-cy="document-preview-modal-close-button"
                    variant="ghost"
                    color="neutral"
                    @click.stop="onClickCloseDocumentPreviewModal"
                />
            </div>
            <document-preview
                class="overflow-scroll flex-grow"
                :document-meta-uuid="selectedDocumentMetaUuid!"
                is-hide-header
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import {onUnmounted, ref, useTemplateRef} from 'vue'
import {useDocumentPreviewModalService} from '@/transaction-journal/DocumentPreview.modal.service'
import HoverToOpenToggle from '@/transaction-journal/HoverToOpenToggle.vue'
import CyclePresetSizeButton from '@/transaction-journal/CyclePresetSizeButton.vue'
import {useDraggable} from '@vueuse/core'
import hotkeys from 'hotkeys-js'
import {debounce} from 'lodash'
import emitter from '@/services/infrastructure/emitter'
import {ORG_SWITCHED} from '@/types/events'
import DocumentPreview from '@/document/DocumentPreview.vue'
import {DocumentMeta} from '@/types/transaction/DocumentMeta'

const documentMeta = ref<DocumentMeta>()
const draggableElement = useTemplateRef('draggableElement')
const dragHandler = useTemplateRef('dragHandler')
const {selectedDocumentMetaUuid, documentPreviewModalSize, documentPreviewModalPosition, ensureSafePosition, onClickCloseDocumentPreviewModal} = useDocumentPreviewModalService()
const {style, isDragging} = useDraggable(draggableElement, {
    initialValue: documentPreviewModalPosition,
    onEnd: ensureSafePosition,
    handle: dragHandler
})

emitter.on(ORG_SWITCHED, close)

window.onresize = debounce(close, 100)
hotkeys('esc', close)

onUnmounted(() => {
    documentMeta.value = undefined
})

</script>

<style scoped>

</style>